/*
 * Key Codes (events)
 */
import { freeze } from './object';
var KEY_CODES = freeze({
  SPACE: 32,
  ENTER: 13,
  ESC: 27,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,
  PAGEUP: 33,
  PAGEDOWN: 34,
  HOME: 36,
  END: 35,
  TAB: 9,
  SHIFT: 16,
  CTRL: 17,
  BACKSPACE: 8,
  ALT: 18,
  PAUSE: 19,
  BREAK: 19,
  INSERT: 45,
  INS: 45,
  DELETE: 46
});
export default KEY_CODES;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/utils/key-codes.js
// module id = 31
// module chunks = 44